import { useTheme } from 'next-themes';
import { ArrowLeft, ArrowRight, Moon, Sun } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const PricingHeader = ({ showSectionLinks = true }: { showSectionLinks?: boolean }) => {
  const { user } = useAuth();
  const { setTheme } = useTheme();
  const linkCls = 'no-underline inline-flex shrink-0 items-center gap-2 min-h-12 whitespace-nowrap text-sm sm:text-base font-medium text-foreground hover:text-primary transition-colors';

  return (
    <header className="border-b border-border sticky top-0 z-50 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex flex-wrap justify-between items-center min-h-16 md:h-20 gap-x-2" aria-label="Pricing navigation">
          <div className="flex min-w-0 items-center gap-3 sm:gap-10">
            <Link to={user ? '/dashboard' : '/'} className={linkCls}>
              <ArrowLeft className="h-4 w-4 shrink-0" />
              {user ? 'Dashboard' : 'Home'}
            </Link>
            {showSectionLinks && (
              <>
                 <Link to="/blog" className={`${linkCls} hidden sm:inline-flex`}>Journal</Link>
                 <Link to="/help" className={`${linkCls} hidden sm:inline-flex`}>Help</Link>
              </>
            )}
          </div>
          <div className="flex items-center gap-1 sm:gap-4">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  aria-label="Toggle color theme"
                   className="relative h-12 w-12 shrink-0 text-primary hover:text-primary hover:bg-primary/10"
                >
                  <Moon className="h-[18px] w-[18px] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
                  <Sun className="absolute h-[18px] w-[18px] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
                  <span className="sr-only">Toggle theme</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={() => setTheme('light')}>Light</DropdownMenuItem>
                <DropdownMenuItem onClick={() => setTheme('dark')}>Dark</DropdownMenuItem>
                <DropdownMenuItem onClick={() => setTheme('system')}>System</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            <Link to={user ? '/dashboard' : '/auth'} className={`${linkCls} text-primary`}>
              {user ? 'My trips' : 'Log In'}
               <ArrowRight className="h-4 w-4 shrink-0" />
            </Link>
          </div>
          {showSectionLinks && <div className="flex basis-full items-center gap-6 border-t border-border sm:hidden">
            <Link to="/blog" className={linkCls}>Journal</Link>
            <Link to="/help" className={linkCls}>Help</Link>
          </div>}
        </nav>
      </div>
    </header>
  );
};
